import type { Option } from "@sorcery/db";

import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "../../ui/select";

export const MultiSelect = ({
  options,
  onSelect,
  placeholder,
  defaultValue,
  arrow = false,
}: {
  options: Option[];
  onSelect: (items: Option[]) => void;
  placeholder: string;
  defaultValue?: Option[];
  arrow?: boolean;
}) => {
  const [selected, setSelected] = useState<Option[]>(defaultValue ?? []);

  return (
    <Select>
      <SelectTrigger arrow={arrow} multi count={selected.length}>
        {/* since we control the select behaviour manually, we need to map and show the values here rather than rely on radix ui internals */}
        {/* leave this wrapped in a div then span for the css selectors to work properly */}
        <div>
          <span>{selected.length ? selected.map((s) => s.label).join(", ") : placeholder}</span>
        </div>
      </SelectTrigger>
      <SelectContent>
        {options.map((c) => (
          <SelectItem
            key={c.label}
            value={c.value}
            // manually control the selected state visual styles
            className={
              selected.some((s) => s.value === c.value)
                ? "!bg-slate-100 !text-slate-900"
                : "hover:!bg-slate-100 hover:!text-slate-900 data-[state=checked]:bg-secondary data-[state=checked]:text-text-color"
            }
            // control selected states in onpointerdown on the child div to avoid radix ui's default behavior of only allowing a single element selected
            onPointerDown={() => {
              setSelected((prev) => {
                const wasSelected = !!prev.find((s) => s.value === c.value);
                console.log(wasSelected);
                let newSelected: Option[] = [];
                if (wasSelected) {
                  newSelected = prev.filter((s) => s.value !== c.value);
                } else {
                  // biome-ignore lint/style/noNonNullAssertion: <explanation>
                  newSelected = [...prev, options.find((s) => s.value === c.value)!];
                }
                onSelect(newSelected);
                return newSelected;
              });
            }}
          >
            {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
